@if (isLoaded) {
  @if (!isReadOnlyMode) {
    <rt-note-form
      [active]="state.notesBeingEdited.includes(NEW_NOTE_ID)"
      [note]="$any({ id: NEW_NOTE_ID })"
      [placeholder]="'app.requisitions.notes.placeholder' | translate"
      [autosave]="false"
      [noteSaveLoading]="state.notesBeingSaved && state.notesBeingSaved.includes(NEW_NOTE_ID)"
      [attachmentLoading]="
        state.noteAttachmentsBeingUploaded[NEW_NOTE_ID]
          ? !!state.noteAttachmentsBeingUploaded[NEW_NOTE_ID].length
          : false
      "
      [attachmentsTemp]="state.noteAttachmentsTemp && state.noteAttachmentsTemp[NEW_NOTE_ID]"
      [canDeleteAttachments]="true"
      [noteToMention]="recruiteeNotesService.noteToMention"
      [localStorageKeyBuilder]="localStorageKeyBuilder"
      [visibilitySelectorComponent]="recruiteeNotesService.visibilitySelectorComponent"
      [visibilityComponentInputs]="{}"
      (noteSaveClick)="noteSaveClick($event)"
      (cancelClick)="noteDiscardClick($event)"
      (noteEditClick)="noteEditClick($event)"
      (uploadAttachmentClick)="uploadAttachmentClick($event)"
      (deleteAttachmentClick)="deleteAttachmentClick($event)"
      (typingStart)="handleNoteTypingStart({ replyToId: undefined })"
      (typingFinish)="handleNoteTypingFinish()"
      margin-bottom
    >
    </rt-note-form>
  }
  <rt-notes-list
    [notes]="state.notes.data!"
    [notesBeingEdited]="state.notesBeingEdited"
    [notesBeingRepliedTo]="state.notesBeingRepliedTo"
    [canHighLevelDataAccess]="hasHighLevelDataAccess"
    [currentlyTypedNotes]="currentlyTypedNotes"
    [notesBeingSaved]="state.notesBeingSaved"
    [notesBeingDeleted]="state.notesBeingDeleted"
    [noteAttachmentsTemp]="state.noteAttachmentsTemp"
    [noteAttachmentsBeingUploaded]="state.noteAttachmentsBeingUploaded"
    [canDeleteAttachments]="true"
    [isReadOnly]="isReadOnlyMode"
    [isOwnerFn]="recruiteeNotesService.isOwnerFn"
    [getOwnerFn]="recruiteeNotesService.getOwnerFn"
    [isAutomatedActionNoteFn]="recruiteeNotesService.isAutomatedActionNoteFn"
    [noteToMention]="recruiteeNotesService.noteToMention"
    [localStorageKeyBuilder]="localStorageKeyBuilder"
    [visibilitySelectorComponent]="recruiteeNotesService.visibilitySelectorComponent"
    [visibilityComponentInputs]="{}"
    (noteSaveClick)="noteSaveClick($event)"
    (noteChecklistClick)="noteChecklistClick($event)"
    (noteDeleteClick)="noteDeleteClick($event)"
    (notePinClick)="notePinClick($event)"
    (noteUnpinClick)="noteUnpinClick($event)"
    (noteEditClick)="noteEditClick($event)"
    (noteReplyClick)="noteReplyClick($event)"
    (noteDiscardClick)="noteDiscardClick($event)"
    (uploadAttachmentClick)="uploadAttachmentClick($event)"
    (deleteAttachmentClick)="deleteAttachmentClick($event)"
    (replyTypingStart)="handleNoteTypingStart($event)"
    (replyTypingFinish)="handleNoteTypingFinish()"
  >
  </rt-notes-list>

  @if (!state.notes.data?.length) {
    <rt-empty-state
      [icon]="'comment'"
      [title]="'app.requisitions.notes.empty_state.title' | translate"
      [desc]="'app.requisitions.notes.empty_state.description' | translate"
      variant="default"
    >
    </rt-empty-state>
  }
} @else {
  <rt-spinner></rt-spinner>
}
